import { render, staticRenderFns } from "./FactorEditDialog.vue?vue&type=template&id=3ba96830"
import script from "./FactorEditDialog.vue?vue&type=script&lang=js"
export * from "./FactorEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports